import { firstValueFrom } from 'rxjs'
import { getOrgPrimerHistory, getPrimerRegistry } from '../../Repository/Primer/PrimerRepository.ts'
import type { RegistryPrimer } from '../../Generated/RegistryPrimer.ts'
import type { OrgPrimerHistory } from '../../Generated/OrgPrimerHistory.ts'
import type { RegistryRow } from './discovery.ts'

export const toRegistryRows = (primers: readonly RegistryPrimer[]): RegistryRow[] =>
  primers.map(({ forwardName, forwardSequence, reverseName, reverseSequence, amplicon }) => ({
    forwardName,
    forwardSequence,
    reverseName,
    reverseSequence,
    amplicon
  }))

let registry: Promise<RegistryRow[] | null> | null = null
let history: Promise<OrgPrimerHistory> | null = null

/** The live primer registry for the read scan, once per session; `null` when it cannot be loaded. */
export const loadPrimerRegistry = (): Promise<RegistryRow[] | null> => {
  registry ??= firstValueFrom(getPrimerRegistry()).then(
    (primers) => toRegistryRows(primers ?? []),
    (error: unknown) => {
      console.info('Primer registry not available to the order wizard', error)
      registry = null
      return null
    }
  )
  return registry
}

/** The organisation's own earlier primer entries, once per session; none when unavailable. */
export const loadPrimerHistory = (): Promise<OrgPrimerHistory> => {
  history ??= firstValueFrom(getOrgPrimerHistory()).then(
    (loaded) => loaded ?? { orderCount: 0, entries: [] },
    (error: unknown) => {
      console.info('Primer history not available to the order wizard', error)
      history = null
      return { orderCount: 0, entries: [] }
    }
  )
  return history
}

/** Forgets the loaded registry and history; for tests, which share the module across cases. */
export const resetPrimerLoaders = () => {
  registry = null
  history = null
}
